module.exports = __webpack_public_path__ + "static/media/turtle-sc.b72f3794.jpg";